// import { PatientInfo } from "./details/program-details";
// import { PatientLogTabs } from "./tab/tabs";
import { Patient } from "../api/types";
import { useQuery } from "@tanstack/react-query";
import { patientDetailsQueryOptions } from "../api/queries";
import { getRouteApi} from "@tanstack/react-router";
// import { UrgentCarePatientLogTabs } from "./tab/urgent-tabs";
import { UrgentCareDetailsTabs } from "./tab/urgent-details-tabs";
import { Button } from "@workspace/web-ui/components/button";
import { useActiveSessionStore } from "../store/active-session-store";
import { ArrowLeft, CheckCircle, Circle, Clock } from "lucide-react";
import { cn } from "@workspace/web-ui/lib/utils";
// import { ActionTask } from "../../encounters/components/urgent-action-task";

interface PatientDetailsProps {
    patient: Patient;
    fromPage?: boolean;
    session?: any;
}

const UrgentCareSessionDetails = ({ patient, session, fromPage }: PatientDetailsProps) => {
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
    const { program } = routeApi.useParams();
    // const navigate = useNavigate();
    const { close, selectedSession } = useActiveSessionStore()
    
    // Use selectedSession from store if available, otherwise fall back to session prop
    const activeSession = selectedSession || session;
    
    useQuery(patientDetailsQueryOptions(patient?.userId ?? "", program ?? ""))

    // Get the session title from the active session
    const sessionTitle = activeSession?.diagnosis?.[0]?.disease_name || "Session Details";

    // Handle back button click based on fromPage prop
    const handleBackClick = () => {
        if (fromPage) {
            // Go back to the previous page in browser history
            window.history.back();
        } else {
            // Use the normal close function
            close();
        }
    };

    return (
        <div className="flex flex-col gap-4 rounded-[12px]">
            <div className="flex flex-col justify-start items-start gap-4">
                <div>
                    <Button
                        className="flex gap-1.5 sm:gap-2 p-2 sm:p-2.5 w-fit bg-white rounded-lg border border-gray-100 transition-all duration-200 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary group"
                        onClick={handleBackClick}
                    >
                        <ArrowLeft
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-foreground transition-transform group-hover:-translate-x-0.5"
                            aria-hidden="true"
                        />
                        <span className="text-xs sm:text-sm font-bold text-black -mt-0.5">
                            Back
                        </span>
                    </Button>
                </div>
                {/* <PatientInfo patient={patient} /> */}
            </div>
            <div className="flex flex-col gap-4 mt-5 rounded-[12px] p-2 bg-white">
                <div className="px-3">
                    <div className="flex items-center justify-between w-full">
                        <h1 className="text-[18px] font-medium">{sessionTitle}</h1>
                        <div className="flex gap-2">
                            <div className={cn(
                                "flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium",
                                activeSession?.payment_status !== "paid"
                                    ? "bg-[#4272DD1A] text-[#4272DD]"
                                    : "bg-[#E6FAF2] text-[#00C781]"
                            )}>
                                {activeSession?.payment_status !== "paid" ? (
                                    <CheckCircle className="w-3 h-3" />
                                ) : (
                                    <Clock className="w-3 h-3" />
                                )}
                                {activeSession?.payment_status !== "paid" ? "In progress" : "Payment Complete"}
                            </div>
                            <div className={cn(
                                "flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium",
                                activeSession?.treatment_completed
                                    ? "bg-[#6E23C91A] text-[#6E23C9]"
                                    : activeSession?.state === "in_progress"
                                        ? "bg-[#4272DD1A] text-[#4272DD]" // Orange/yellow styling for pending review
                                        : "bg-[#FFF4E6] text-[#F59E0B]"
                            )}>
                                {activeSession?.treatment_completed ? (
                                    <CheckCircle className="w-3 h-3" />
                                ) : activeSession?.state === "in_progress" ? (
                                    <Circle className="w-3 h-3" />
                                ) : null}
                                {activeSession?.treatment_completed
                                    ? "Treatment completed"
                                    : activeSession?.state === "in_progress"
                                        ? "In Progress"
                                        : "Pending Review"
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <UrgentCareDetailsTabs userId={patient?.userId ?? ""} userDoseSpotId={patient?.user_dosespot_id ?? ""} selectedSession={activeSession || undefined} patient={patient} program={program} />
            </div>

            {/* Action Task Section */}
            {/* {activeSession && (
                <div className="mt-4">
                    <ActionTask 
                        encounterId={activeSession.session_id} 
                        selectedSession={activeSession}
                    />
                </div>
            )} */}
        </div>
    )
}

export default UrgentCareSessionDetails;